export default "__VITE_ASSET__BMp1jy3G__"